const mEditionMapChartNodeTaskModalDelete = {
  mEditionMapChartNodeTaskModalDelete: {
    alerts: {
      deleteContenidoNodo: {
        error: 'Un error ha ocurrido. Vuelve a intentarlo en un momento.',
        success: 'La tarea se eliminó exitosamente.'
      }
    },

    buttonCancel: 'CANCELAR',
    buttonPrimary: 'ELIMINAR',

    messageDelete: {
      element: 'Se eliminará la tarea del paso ',
      options: 'y todas sus características de forma definitiva.',
      notReversed: 'Esta acción no podrá ser revertida.'
    },

    title: 'Eliminar Tarea'
  }
}

export default mEditionMapChartNodeTaskModalDelete
